import { render } from "./AsHeaderMain.vue?vue&type=template&id=ffe28a7c&ts=true"
import script from "./AsHeaderMain.vue?vue&type=script&lang=ts"
export * from "./AsHeaderMain.vue?vue&type=script&lang=ts"

import "./AsHeaderMain.vue?vue&type=style&index=0&id=ffe28a7c&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__